import {
    LOGIN,
    SET_USER,
    SET_PARAMS,
    LOGOUT,
    ADD_ORDER_ITEM,
    MODIFY_ORDER_ITEM,
    REMOVE_ORDER_ITEM,
    CLEAR_ORDER,
    APPLY_DISCOUNT,
    ADD_ACC_ITEM,
    MODIFY_ACC_ITEM,
    REMOVE_ACC_ITEM,
    CLEAR_ACC_QUEUE
} from './actionTypes'

// Auth
export const login = token => ({
    type: LOGIN,
    token
})

export const setuser = user => ({
    type: SET_USER,
    user
})

export const logout = () => ({
    type: LOGOUT
})

// Organization
export const setparams = params => ({
    type: SET_PARAMS,
    params
})

// Order
export const addOrderItem = (variant, item) => ({
    type: ADD_ORDER_ITEM,
    variant,
    item
})

export const modifyOrderItem = (index, qty, price) => {
    return {
        type: MODIFY_ORDER_ITEM,
        index,
        qty,
        price
    }
}

export const applyDiscount = (index, discount) => {
    return {
        type: APPLY_DISCOUNT,
        index,
        discount
    }
}

export const removeOrderItem = index => ({
    type: REMOVE_ORDER_ITEM,
    index
})

export const clearOrder = () => ({
    type: CLEAR_ORDER
})

// Accounting
export const addItemToAccQueue = (item, price) => ({
    type: ADD_ACC_ITEM,
    item,
    price
})

export const modifyAccItem = (index, bulk, contains, price, vat, discount) => {
    return {
        type: MODIFY_ACC_ITEM,
        index,
        bulk,
        contains,
        price,
        vat,
        discount
    }
}

export const removeAccItem = index => ({
    type: REMOVE_ACC_ITEM,
    index
})

export const clearAccQueue = () => ({
    type: CLEAR_ACC_QUEUE
})
